import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Contact from '@fathomtech/nualang-ui-components/dist/Forms/Contact/Contact';
import Snackbar from '@fathomtech/nualang-ui-components/dist/Misc/Snackbar';
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { contactEmail } from '../../utils/api/Notifications';

const NualasHeroImg = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  display: 'block',
  maxHeight: '200px',
}));

const formatInitialValues = (qsParams) => {
  const {
    freeTrial, requestDemo, newsAndUpdates, email,
  } = qsParams;
  return {
    email: email || '',
    freeTrial: freeTrial === 'true',
    requestDemo: requestDemo === 'true',
    newsAndUpdates: newsAndUpdates === 'true',
  };
};

function PublisherContactUs({
  title, image,
}) {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const initialValues = formatInitialValues({});

  const handleSubmit = async (values) => {
    if (!values.message) {
      values.message = 'No Message';
    }
    const response = await contactEmail(values);

    if (response.MessageId) {
      setSubmitted(true);
    } else {
      setSnackbarOpen(true);
    }
  };

  return (
        <div id="publisher-contact-form">
            <Typography
                sx={(theme) => ({
                  [theme.breakpoints.up('md')]: {
                    fontSize: '44px',
                    lineHeight: '56px',
                    marginTop: '2rem',
                  },
                  fontWeight: 'bold',
                  fontSize: '26px',
                  lineHeight: '32px',
                  marginTop: '1rem',
                })}
                variant="h2"
                component="h2"
                textAlign={'center'}
            >
                {title}
            </Typography>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={(theme) => ({
                  [theme.breakpoints.up('md')]: {
                    marginTop: 10,
                  },
                  marginTop: 1,
                })}
            >
                <NualasHeroImg
                    src={image}
                />
            </Grid>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={(theme) => ({
                  [theme.breakpoints.up('md')]: {
                    marginTop: 5,
                  },
                  marginTop: 2,
                })}
            >
                <Contact
                    t={t}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    submitted={submitted}
                    isPublisher={true}
                    disableCheckboxes={true}
                />
            </Grid>
            <Snackbar
                t={t}
                isSnackbarOpen={snackbarOpen}
                closeSnackbar={() => setSnackbarOpen(false)}
                snackbarMessage={t('problem_sending_contact_form')}
                snackbarType={'error'}
            />

        </div>
  );
}

PublisherContactUs.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  image: PropTypes.shape({ type: PropTypes.oneOf(['img', 'svg']) }),
};

export default PublisherContactUs;
